import { ServerErrorField } from "@/components/server-error-field/ServerErrorField.tsx";
import i18n from "@/i18n.ts";
import { Button, Input, useModals, Modal, ModalProps, Stack } from "@skailer-com/uikit";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { useState } from "react";
import { ReviewerTypeItem } from "@/pages/talent/performance-reviews/edit/performance-review-edit.ts";
import { ApiPerformanceReviewReviewerTypes } from "@/types/performance-review.types.ts";

export interface PerformanceReviewReviewerTypeAddOrEditModalProps extends ModalProps {
  reviewerTypeItem?: ReviewerTypeItem;
  onSave: (reviewerTypeItem: ReviewerTypeItem) => Promise<void>;
}

export function PerformanceReviewReviewerTypeAddOrEditModal({
  reviewerTypeItem,
  onSave,
  ...props
}: PerformanceReviewReviewerTypeAddOrEditModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = { ...props };
  const [isSaving, setIsSaving] = useState(false);

  const schema = yup.object({
    title: yup.string().required(i18n.t("errors:field_required")),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<yup.InferType<typeof schema>>({
    mode: "onSubmit",
    resolver: yupResolver(schema),
    defaultValues: {
      title: reviewerTypeItem?.title ?? "",
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    setIsSaving(true);
    const item = reviewerTypeItem
      ? reviewerTypeItem
      : {
          id: null,
          title: null,
          type: ApiPerformanceReviewReviewerTypes.custom,
        };

    await onSave({ ...item, ...data });
    setIsSaving(false);
    close(id);
  });

  return (
    <Modal
      {...props}
      title={t("performance_review:reviewer_type")}
      withCloser
      actions={
        <Stack gap={"sm"}>
          <ServerErrorField errors={errors} />
          <Button type={"submit"} size={"lg"} onClick={onSubmit} isLoading={isSaving}>
            {t("common:save")}
          </Button>
        </Stack>
      }
    >
      <form onSubmit={onSubmit}>
        <Input
          label={t("common:title")}
          required={true}
          type={"text"}
          autoFocus={true}
          {...register("title")}
          error={errors.title?.message}
        />
      </form>
    </Modal>
  );
}
